import { create } from 'zustand';
import { copy } from '../copy/copy';

export interface BrandSettings {
  titleId: string;
  titleAr: string;
  subtitleId: string;
  subtitleAr: string;
}

const STORAGE_KEY = 'lms_admin_branding_settings';

export const DEFAULT_BRAND_SETTINGS: BrandSettings = {
  titleId: copy.sidebar.brandName.id, // 'Tarbiyah Panel'
  titleAr: copy.sidebar.brandName.ar, // 'لوحة التربية'
  subtitleId: copy.sidebar.brandSub.id, // 'Heritage Learning'
  subtitleAr: copy.sidebar.brandSub.ar, // 'التعليم التراثي'
};

const safeGetBrandSettings = (): BrandSettings => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_BRAND_SETTINGS;
    const parsed = JSON.parse(raw) as Partial<BrandSettings>;
    return {
      titleId:
        typeof parsed.titleId === 'string' && parsed.titleId
          ? parsed.titleId
          : DEFAULT_BRAND_SETTINGS.titleId,
      titleAr:
        typeof parsed.titleAr === 'string' && parsed.titleAr
          ? parsed.titleAr
          : DEFAULT_BRAND_SETTINGS.titleAr,
      subtitleId:
        typeof parsed.subtitleId === 'string' && parsed.subtitleId
          ? parsed.subtitleId
          : DEFAULT_BRAND_SETTINGS.subtitleId,
      subtitleAr:
        typeof parsed.subtitleAr === 'string' && parsed.subtitleAr
          ? parsed.subtitleAr
          : DEFAULT_BRAND_SETTINGS.subtitleAr,
    };
  } catch {
    return DEFAULT_BRAND_SETTINGS;
  }
};

interface BrandingState {
  settings: BrandSettings;
  updateSettings: (newSettings: Partial<BrandSettings>) => void;
  resetSettings: () => void;
}

export const useBrandingStore = create<BrandingState>(set => ({
  settings: safeGetBrandSettings(),
  updateSettings: newSettings => {
    set(state => {
      const merged: BrandSettings = {
        ...state.settings,
        ...newSettings,
      };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
      } catch {
        // ignore
      }
      return { settings: merged };
    });
  },
  resetSettings: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
    set({ settings: DEFAULT_BRAND_SETTINGS });
  },
}));
